jQuery(($) => {
  // =================
  // Site Loaded
  // =================
  setTimeout(() => {
    $('body').addClass('has-loaded');
    console.log('site loaded successfully.');
  }, 100);

  // =================
  // Wrap Heading Words
  // =================
  $('.heading--style1').each(function () {
    $(this).html(
      $(this)
        .text()
        .trim()
        .split(/\s+/)
        .map((word) => `<span class="title-word">${word}</span>`)
        .join(' ')
    );
  });

  // =================
  // Hover Video Play
  // =================
  if (window.innerWidth >= 1024) {
    $('.story--video--wrap')
      .each(function () {
        $(this).find('video').attr('data-progress', 0);
      })
      .on('mouseenter mouseleave', function (e) {
        const video = $(this).find('video').get(0);
        if (!video) return;

        if (e.type === 'mouseenter') {
          video.currentTime = $(video).attr('data-progress');
          video.play();
        } else {
          $(video).attr('data-progress', video.currentTime);
          video.pause();
          video.currentTime = 0;
        }
      });
  }

  // =======
  // Open first accordion item by default
  // ========
  const firstItem = $('.accordion-item').first();
  const firstContent = firstItem.find('.accordion-content');

  if (firstContent.length) {
    firstItem.addClass('active');
    // firstContent.css('max-height', firstContent[0].scrollHeight + 'px');
  }

  // ===== Accordion Function ========
  $('.accordion-item').on('click', function () {
    const item = $(this).closest('.accordion-item');

    // Close all other accordions
    $('.accordion-item').not(item).removeClass('active');

    // Toggle current accordion
    item.toggleClass('active');
  });

  // Popup Download Resources File
  $('.manual-download-btn').on('click', function (e) {
    e.preventDefault();

    const fileId = $(this).text().trim();
    $('input[name="download_file_id"]').val(fileId);

    $('#download-popup').fadeIn();
    $('html, body').addClass('download-open');
  });

  // Close popup button
  $('.download-popup-close').on('click', function (e) {
    e.preventDefault();
    closeDownloadPopup();
  });

  // Close only when clicking the overlay
  $('#download-popup').on('click', function (e) {
    if (e.target === this) {
      closeDownloadPopup();
    }
  });

  // Reusable function
  function closeDownloadPopup() {
    $('#download-popup').fadeOut();
    $('html, body').removeClass('download-open');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // FancyBox popup gallery
  console.log('DOM fully loaded and parsed');
  Fancybox.bind('[data-fancybox="pop-gallery"]', {
    Thumbs: {
      autoStart: false,
    },
  });

  // Location
  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);

    if (target) {
      setTimeout(() => {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 300);
    }
  }
});

// for keyboard focus in button
let isUsingKeyboard = false;

document.addEventListener('keydown', function (e) {
  if (e.key === 'Tab') {
    isUsingKeyboard = true;
    document.body.classList.add('using-keyboard');
  }
});

document.addEventListener('mousedown', function () {
  if (isUsingKeyboard) {
    isUsingKeyboard = false;
    document.body.classList.remove('using-keyboard');
  }
});

jQuery(document).ready(function ($) {
  function addPDFLinksInsideSuccess() {
    const successDiv = $('#fluentform_4_success');
    if (successDiv.length && successDiv.is(':visible')) {
      // Prevent duplicate content
      if (successDiv.find('#pdf-resources-container').length) return;
      let pdfHtml = `
                <div id="pdf-resources-container">
                    <ul class="pdf-link-wrap">
            `;
      $('.register-btn .manual-download-btn').each(function () {
        const $link = $(this);
        const fileUrlBase64 = $link.data('file-url');
        const fileName = $link.text().trim();

        let decodedUrl = fileUrlBase64;
        try {
          decodedUrl = atob(fileUrlBase64);
        } catch (e) {
          // console.warn('Base64 decode failed for:', fileName);
        }
        pdfHtml += `
                    <li>
                        <a href="${decodedUrl}"
                           target="_blank"
                           class="manual-download-btn">
                             ${fileName}
                        </a>
                    </li>`;
      });

      pdfHtml += `</ul></div>`;
      // Append INSIDE the success message
      successDiv.append(pdfHtml);
      // console.log('PDF links added inside fluentform_4_success');
    }
  }
  // Initial check
  addPDFLinksInsideSuccess();
  // Watch for dynamic insertion by Fluent Forms
  const observer = new MutationObserver(addPDFLinksInsideSuccess);
  observer.observe(document.body, { childList: true, subtree: true });
  // Fluent Forms specific event fallback
  $(document).on('fluentform_submission_success', function () {
    setTimeout(addPDFLinksInsideSuccess, 200);
  });
});
